import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UiModule } from '@app/ui';
import { NavMenuItem } from '../header-nav-menu-item.model';

@Component({
  selector: 'gb-header-nav-menu-section',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, UiModule],
  templateUrl: './header-nav-menu-section.component.html',
})
export class HeaderNavMenuSectionComponent {
  readonly title = input<string | null>(null);
  readonly items = input.required<NavMenuItem[]>();

  // Action rows close the panel through their own action(), so only link rows emit.
  readonly linkClick = output<void>();
}
